import { gsap, Power2 } from 'gsap'
import * as L           from 'leaflet'
import 'leaflet-active-area'
// import { MarkerClusterGroup } from 'leaflet.markercluster'
// import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet/dist/leaflet.css'
import SimpleBar        from 'simplebar'
import 'simplebar/dist/simplebar.min.css'
import 'unfetch'
import markerIconActive from '../images/marker-active.svg'
// import markerIconCluster      from '../images/marker-cluster.svg'
import markerIcon       from '../images/marker.svg'
import '../scss/index.scss'

const data = {
	locations: [
		{
			display: true,
			id: 2,
			title: 'Annecy',
			adresse: '91 impasse des champs',
			code_postal: '74350',
			ville: 'Allonzier-la-caille',
			contact: 'Mickael Hébert',
			email: 'mhebert@easy-module.com',
			telephone: '+33 (0)6 15 42 20 11',
			lien: 'https://www.easy-module.com/ou-nous-trouver/annecy'
		},
		{
			display: true,
			id: 3,
			title: 'Genève',
			adresse: 'Rue de la Rôtisserie 6',
			code_postal: '1204',
			ville: 'Genève',
			contact: 'Mickael Hébert',
			email: 'mhebert@easy-module.com',
			telephone: '+41 (0)76 399 11 20',
			lien: 'https://www.easy-module.com/ou-nous-trouver/geneve'
		},
		{
			display: true,
			id: 1,
			title: 'Nantes',
			adresse: '11 rue de l\'Industrie',
			code_postal: '44140',
			ville: 'Aigrefeuille-sur-Maine',
			contact: 'Frédéric Zavagno',
			email: 'fzavagno@easy-module.com',
			telephone: '+33 (0)6 09 74 41 05',
			lien: 'https://www.easy-module.com/ou-nous-trouver/nantes'
		}
	]
}

const params = {
	activeMarker: null,
	maps: []
}

class Map
{
	constructor (data)
	{
		this.data = data
		this.container = document.querySelector('#map_container')
		this.sidebar = this.container.querySelector('#map_sidebar')
		this.sidebarContent = this.sidebar.querySelector('.inner')
		// this.sidebarToggle = this.container.querySelector('#map_sidebar_toggle')
		this.sidebarToggle = this.sidebar.querySelector('.close')
		this.defaultSidebarContent = this.sidebarContent.innerHTML
		this.maxWidth = 1200
		this.simplebar = new SimpleBar(this.sidebar)
		
		this.resizeMap()
		
		if (this.data.main)
		{
			this.preloadImages()
			
			this.sidebarToggle.addEventListener('click', e =>
			{
				if (params.activeMarker)
				{
					params.activeMarker.fireEvent('click')
				}
			})
			
			window.addEventListener('resize', () =>
			{
				this.resizeMap()
			})
		}
		
		this.initMap()
	}
	
	preloadImages ()
	{
		Array.from(data.locations).forEach(el =>
		{
			if (el.logo)
			{
				const img = document.createElement('img')
				img.src = el.logo
				
				document.querySelector('#map_preload').append(img)
			}
		})
	}
	
	resizeMap ()
	{
		let header = document.querySelector('#header')
		let mapHeight = innerHeight
		let headerHeight = 0
		
		if (header)
		{
			headerHeight = header.clientHeight
			mapHeight -= headerHeight
		}
		
		gsap.set(this.container, {
			height: mapHeight
		})
		
		if (this.map)
		{
			this.setActiveArea()
			
			/*let zoom = innerWidth / 100
			 
			 if (zoom < 4)
			 {
			 zoom = 4
			 }
			 
			 if (zoom > 6)
			 {
			 zoom = 6
			 }
			 
			 zoom = Math.floor(zoom)
			 
			 this.map.setZoom(zoom)*/
			
			/*if (innerWidth < this.maxWidth)
			 {
			 this.map.zoomControl.remove()
			 }*/
		}
	}
	
	setActiveArea ()
	{
		if (innerWidth > this.maxWidth)
		{
			const sidebarWidth = this.sidebar.clientWidth
			
			this.map.setActiveArea({
				position: 'absolute',
				top: '100px',
				left: sidebarWidth + 100 + 'px',
				right: '100px',
				bottom: '100px'
			})
		}
		else
		{
			this.map.setActiveArea({
				position: 'absolute',
				top: '20px',
				left: '20px',
				right: '20px',
				bottom: '20px'
			})
		}
	}
	
	initMap ()
	{
		this.map = L.map(this.data.container, {
			center: this.data.latlng,
			zoomSnap: 0.1,
			zoomDelta: 0.5,
			zoom: this.getZoom(),
			// minZoom: innerWidth < this.maxWidth ? this.getZoom() - 3 : this.getZoom() - 2,
			//minZoom: innerWidth < this.maxWidth ? this.getZoom() - 3 : innerWidth/200,
			maxBoundsViscosity: 1,
			attributionControl: this.data.attributionControl,
			zoomControl: this.data.zoomControl,
			scrollWheelZoom: true,
			gestureHandling: true,
			tap: false
		})
		
		this.setActiveArea()
		this.addSidebarContent()
		
		params.maps = [...params.maps, this.map]
		
		const osmMapnik = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
		})
		
		const cartoPositron = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
			attribution: '&copy; <a href="https://carto.com">Carto</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
		})
		
		this.map.addLayer(cartoPositron)
		
		/*const cluster = new MarkerClusterGroup({
		 removeOutsideVisibleBounds: true,
		 animate: true,
		 spiderfyOnMaxZoom: true,
		 showCoverageOnHover: false,
		 zoomToBoundsOnClick: true,
		 spiderfyDistanceMultiplier: 2,
		 iconCreateFunction: (cluster) =>
		 {
		 const html = cluster.getChildCount()
		 
		 return L.divIcon({
		 html: `<img src="${markerIconCluster}"><span>${html}</span>`
		 })
		 }
		 })*/
		
		let markers = []
		let i = 0
		
		Array.from(data.locations).forEach(el =>
		{
			this.checkLatlng(el).then(latlng =>
			{
				if (latlng)
				{
					const marker = this.addMarker(this.map, el, latlng)
					// cluster.addLayer(marker)
					
					if (el.display)
					{
						this.map.addLayer(marker)
					}
					
					markers = [...markers, latlng]
				}
				
				i++
				
				if (i === data.locations.length)
				{
					const bounds = L.latLngBounds(markers)
					
					this.map.fitBounds(bounds, {
						// maxZoom: innerWidth < this.maxWidth ? this.getZoom() - 2 : this.getZoom() - 4
						maxZoom: innerWidth < this.maxWidth ? this.getZoom() - 3 : this.getZoom() - 2
					})
				}
			})
		})
		
		// this.map.addLayer(cluster)
		
		if (this.data.main)
		{
			this.resizeMap()
		}
	}
	
	getZoom ()
	{
		return this.map ? this.map.getZoom() : this.data.zoom
	}
	
	centerMap ()
	{
		if (innerWidth < this.maxWidth || this.map.getZoom() > this.data.zoom)
		{
			return
		}
		
		const isOpen = this.sidebar.classList.contains('open')
		const offset = gsap.getProperty(this.sidebar, 'width') / 2
		const point = this.map.latLngToContainerPoint(this.data.latlng)
		let newPoint
		
		if (!isOpen)
		{
			newPoint = L.point([point.x, point.y])
		}
		else
		{
			newPoint = L.point([point.x + offset, point.y])
		}
		
		const newLatLng = this.map.containerPointToLatLng(newPoint)
		
		this.map.setView(newLatLng, this.map.getZoom(), {
			animate: true,
			duration: .5,
			easeLinearity: 0.58
		})
	}
	
	toggleSidebar (force = false)
	{
		if (innerWidth >= this.maxWidth)
		{
			return
		}
		
		const isOpen = this.sidebar.classList.contains('open')
		
		this.sidebarToggle.classList.toggle('open')
		this.sidebar.classList.toggle('open')
		
		gsap.to(this.sidebar, {
			xPercent: isOpen ? 0 : 100,
			duration: .5,
			ease: Power2.easeOut
		})
	}
	
	getIcon (active = false)
	{
		return L.icon({
			iconUrl: active ? markerIconActive : markerIcon,
			iconSize: [40, 40],
			iconAnchor: [20, 40],
			tooltipAnchor: [1, -50]
		})
	}
	
	addMarker (map, el, latlng)
	{
		const marker = L.marker(latlng, {
			icon: this.getIcon(),
			opacity: 1,
			interactive: true,
			keyboard: false
		})
		
		marker.infos = el
		
		marker.on('mouseover', () => this.onMouseover(marker))
		marker.on('mouseout', () => this.onMouseout(marker))
		marker.on('click', (force) => this.onClick(marker, force))
		marker.bindTooltip(el.title, {
			direction: 'top',
			permanent: true,
			opacity: 0
		})
		
		return marker
	}
	
	showTooltip (marker)
	{
		gsap.fromTo(marker._tooltip._container, {
			top: -10,
			opacity: 0
		}, {
			opacity: 1,
			top: 0,
			duration: .3,
			ease: Power2.easeOut
		})
	}
	
	hideTooltip (marker)
	{
		gsap.to(marker._tooltip._container, {
			opacity: 0,
			duration: .3,
			ease: Power2.easeOut
		})
	}
	
	addSidebarContent ()
	{
		let template = ''
		
		data.locations.filter(_ => _.display).forEach(el =>
		{
			/*template += `
			 <div class="item" data-id="${el.id}">
			 <h2><span>Easy Module</span> ${el.title}</h2>
			 
			 <div class="item-details">
			 <div class="adresse">${el.adresse}</div>
			 <div class="adresse-2">${el.code_postal} ${el.ville}</div>
			 <div class="contact">Contact : ${el.contact}</div>
			 <div class="email">Email : ${el.email}</div>
			 <div class="telephone">Téléphone : ${el.telephone}</div>
			 </div>
			 
			 <div class="button">
			 <a href="${el.lien}">En savoir plus</a>
			 </div>
			 </div>
			 `*/
			template += `
				<div class="item" data-id="${el.id}">
					<h2><span>Easy Module</span> ${el.title}</h2>
					
					<div class="item-details">
						<div class="adresse">${el.adresse}</div>
						<div class="adresse-2">${el.code_postal} ${el.ville}</div>
					</div>
					
					<div class="button">
						<a href="${el.lien}">Détail</a>
					</div>
				</div>
			`
		})
		
		this.sidebarContent.innerHTML = template
	}
	
	updateContent (marker)
	{
		const items = this.sidebar.querySelectorAll('.item')
		const scroll = this.simplebar.getScrollElement()
		
		items.forEach(_ =>
		{
			_.classList.remove('selected')
		})
		
		if (params.activeMarker === marker)
		{
			const item = Array.from(items).filter(_ => parseInt(_.dataset.id) === marker.infos.id)
			
			if (item.length)
			{
				const top = item[0].getBoundingClientRect().top - this.sidebar.getBoundingClientRect().top - gsap.getProperty(this.sidebarContent, 'padding-top')
				
				scroll.scrollTo({
					top: top,
					behavior: 'smooth'
				})
				
				item[0].classList.add('selected')
			}
		}
		else
		{
			scroll.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		}
	}
	
	onMouseover (marker)
	{
		this.showTooltip(marker)
	}
	
	onMouseout (marker)
	{
		this.hideTooltip(marker)
	}
	
	onClick (marker, force)
	{
		if (params.activeMarker)
		{
			if (params.activeMarker === marker)
			{
				marker.setIcon(this.getIcon())
				params.activeMarker = null
				
				this.updateContent()
				this.toggleSidebar()
			}
			else
			{
				marker.setIcon(this.getIcon(true))
				params.activeMarker.setIcon(this.getIcon())
				params.activeMarker = marker
				
				this.updateContent(marker)
			}
		}
		else
		{
			marker.setIcon(this.getIcon(true))
			params.activeMarker = marker
			
			this.updateContent(marker)
			this.toggleSidebar()
		}
	}
	
	async checkLatlng (el)
	{
		if (!el.latlng || el.latlng.trim() === '')
		{
			return await this.getLatLng(el).then(res =>
			{
				return res
			})
		}
		
		if (!el.ville || el.ville.trim() === '')
		{
			return
		}
		
		return JSON.parse(el.latlng)
	}
	
	async getLatLng (el)
	{
		const latlng = localStorage.getItem('latlng_' + el.id)
		
		if (latlng)
		{
			return JSON.parse(latlng)
		}
		
		if (!el.pays)
		{
			el.pays = 'France'
		}
		
		await new Promise(r => setTimeout(r, 1000))
		
		// return await fetch(`https://nominatim.openstreetmap.org/search?street=${el.adresse}&postalcode=${el.code_postal}&city=${el.ville}&country=${el.pays}&format=json`, {
		return await fetch(`https://nominatim.openstreetmap.org/search?street=${el.adresse}&postalcode=${el.code_postal}&city=${el.ville}&format=json`, {
			method: 'GET'
		}).then((response) =>
		{
			return response.ok ? response.json() : Promise.reject(response.statusText)
		}).then((response) =>
		{
			if (!response)
			{
				return
			}
			
			const latlng = [response[0].lat, response[0].lon]
			
			localStorage.setItem('latlng_' + el.id, JSON.stringify(latlng))
			
			return latlng
		}).catch((error) =>
		{
			alert(error)
		})
	}
}

document.addEventListener('DOMContentLoaded', () =>
{
	const maps = [
		{
			main: true,
			container: document.querySelector('#map'),
			zoom: 8,
			attributionControl: true,
			zoomControl: true,
			maxBounds: [
				[40.094882, -6.591797],
				[52.133488, 10.349121]
			],
			latlng: [46.603354, 1.8883335]
		}
	]
	
	Array.from(maps).forEach(el =>
	{
		new Map(el)
	})
})
